// Copyright (c) BSS-ONE
// Author: Alexandru Bagu (a.bagu at software-dep.net)

export default {
  name: 'workspaces',
  title: 'label.workspaces',
  icon: 'InboxOutlined',
  docHelp: 'workspaces.html',
  permission: ['workspaceStatus', 'ansibleStatus'],
  component: () => import('@/views/plugins/workspaces/Manage.vue')
}
